<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForSecurityForm
        ref="feesForSecurityForm"
        v-model="feesForSecurityFormModel"
        label-width="10em"
        formMode="edit"
        billingYmMode="search"
        :editDisabledMode="editDisabledMode"
        :autocomplete-airport-code-set="airportCodeSet"
        :autocomplete-customer-code-set="customerCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForSecurityForm from '@/components/organisms/dialog/calculation/FeesForSecurityForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForSecurityForm,
    EditDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForSecurityFormModel: {
        billing_ym: undefined,
        bill_to_code: undefined,
        destination_airport_code: undefined,
        route_code: undefined,
        tax: undefined,
        taxation: undefined,
        paid_passengers: undefined,
        passenger_fee: undefined,
        paid_cargo_volume: undefined,
        cargo_volume_fee: undefined,
        // 2022/05/06 髙森 追記 旅客数保安料と貨物量保安料
        passenger_security_fee_with_tax: undefined,
        cargo_security_fee_with_tax: undefined,
        // ここまで
        security_fee_without_tax: undefined,
        security_fee_tax: undefined,
        security_fee_with_tax: undefined,
        regist_type: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForSecurityFormModel.regist_type === '1' || parseInt(this.feesForSecurityFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForSecurityForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-security', this.feesForSecurityFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForSecurityFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'destination_airport_code']
      this.$nextTick(() => {
        this.$refs.feesForSecurityForm.clearFields()
        Object.keys(this.feesForSecurityFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.feesForSecurityFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
